import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { PopoverHint } from 'src/components/BasicComponents';
import { useStore } from '../../../store/reducers';
import { IconCircle } from '../../Icon';

export const prepareTitle = (key: string, title: string, hint?: string): JSX.Element => {
  const filterSet = useStore((s) => s.trackers.filterSet);

  const isFiltered = [...filterSet].some((k) => k.startsWith(`/${key}/`));

  return (
    <Title>
      <Container>
        {title}
        {hint && <PopoverHint>{hint}</PopoverHint>}
      </Container>
      {isFiltered && <CircleIcon />}
    </Title>
  );
};
const Container = styled.div`
  display: flex;
  gap: 5px;
`;

const CircleIcon = styled(IconCircle)`
  font-size: 9px;
  color: ${RacemapColors.PaleBlue}; 
  margin-left: 8px; 
`;

const Title = styled.span`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
